import React from 'react'

import { Col, Collapse, Row } from 'antd'

import Icon from '../../../general/Icon'

import './styles.less'

const MecExplanation: React.FC = () => {
  return (
    <Row className="mec-container">
      <Row>
        <Col span={24}>
          <h6>Additional information:</h6>
          <p>Most policies provide minimum essential coverage if they fall under one of the following categories:</p>
          <Collapse ghost>
            <Collapse.Panel header="Major medical insurance" key="1">
              <label>Examples:</label>
              <ul>
                <li>
                  Platinum, Gold, Silver or Bronze tier insurance plans (as seen on healthcare.gov, StrideHealth, etc.)
                </li>
                <li>
                  Insurance purchased directly from an insurance carrier (Blue Cross Blue Shield, Aetna, Kaiser, Cigna)
                </li>
                <li>Insurance provided by a spouse or parent's employer</li>
              </ul>
            </Collapse.Panel>
            <Collapse.Panel header="Government-sponsored insurance" key="2">
              <p>Government-sponsored insurance</p>
            </Collapse.Panel>
            <Collapse.Panel header="Insurance provided by another or previous employer" key="3">
              <p>Insurance provided by another or previous employer</p>
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>

      <Row className="white-container" gutter={16}>
        <Col span={24}>
          <div className="flex">
            <Icon className="fas fa-exclamation-triangle mr-16 mt-4" />
            <p className="mb-0">
              Short-term plans, health sharing ministries, stand-alone dental and vision plans, and limited benefit or
              discount plans do not qualify as minimum essential coverage.
            </p>
          </div>
        </Col>
      </Row>
    </Row>
  )
}

export default MecExplanation
